import IconSvg from './assets/icons/48/success.svg';
import { FC } from 'react';
const Icon: FC = () => <img alt="success" src={IconSvg} width="48px" height="48px" />;

export default Icon;
